import { createStore, applyMiddleware, combineReducers } from "redux";
import { composeWithDevTools } from "@redux-devtools/extension";
import thunk from "redux-thunk";

import { userReducer } from "./Redux/reducers/userReducers.js";
import { appointmentReducer } from "./Redux/reducers/patientReducers/appointmentReducers.js";
import { medicineReducer } from "./Redux/reducers/patientReducers/medicineReducers.js";
import { labReducer } from "./Redux/reducers/patientReducers/labReducers.js";
import { historyReducer } from "./Redux/reducers/patientReducers/historyReducers.js";
import { adminAppointmentsReducer } from "./Redux/reducers/adminReducers/adminAppointmentReducer.js";
import { adminDoctorsReducer } from "./Redux/reducers/adminReducers/doctorReducers.js";
import { departmentReducer } from "./Redux/reducers/adminReducers/departmentReducers.js"; // unified
import { adminMedicineReducer } from "./Redux/reducers/adminReducers/adminMedicineReducer.js";
import { pharmacistReducer } from "./Redux/reducers/pharmacistReducers/pharmacistMedicineReducers.js";
import { receptionistReducer } from "./Redux/reducers/receptionistReducers/receptionistReducer.js";
import { doctorReducer } from "./Redux/reducers/doctorReducers/doctorReducers.js";
const rootReducer = combineReducers({
  auth: userReducer,
  // Patient
  patientAppointments: appointmentReducer,
  patientMedicines: medicineReducer,
  patientLabs: labReducer,
  patientHistory: historyReducer,
  // Admin
  adminAppointments: adminAppointmentsReducer,
  adminDoctors: adminDoctorsReducer,
  departments: departmentReducer,
  adminMedicines: adminMedicineReducer,
  // Pharmacist
  pharmacy: pharmacistReducer,
  //Receptionist
  receptionist: receptionistReducer,
  //Doctor
  doctor: doctorReducer,
});

const userInfoFromStorage = localStorage.getItem("userInfo")
  ? JSON.parse(localStorage.getItem("userInfo"))
  : null;

const initialState = { auth: { userInfo: userInfoFromStorage } };

const store = createStore(
  rootReducer,
  initialState,
  composeWithDevTools(applyMiddleware(thunk))
);

export default store;
